import type { AccountMapping } from "@dealer-center/ddc-pages-service-account-mappings-interface";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import type { AccountEntity } from "@dealer-center/ddc-api-account-interface";

export interface serviceAccountMappingsFetchInterface {
  accountEntity?: AccountEntity;
}

const queryKeyBase = "ddc-pages-service-account-mappings";

export function useServiceAccountMappingsGet({
  accountEntity
}: serviceAccountMappingsFetchInterface) {
  const accountId = accountEntity?.id;
  return useQuery<AccountMapping>({
    queryKey: [queryKeyBase, accountId],
    enabled: !!accountId,
    queryFn: () => fetchServiceAccountMappingsGet(accountId)
  });
}

export function useServiceAccountMappingsUpdate() {
  const queryClient = useQueryClient();
  return useMutation({
    onError: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeyBase] });
    },
    onSuccess: (newData: AccountMapping, oldData: AccountMapping) => {
      queryClient.setQueryData<AccountMapping>(
        [queryKeyBase, oldData.serviceAccountId],
        newData
      );
    },
    mutationFn: (config: AccountMapping) => {
      return fetchServiceAccountMappingsUpdate(config);
    }
  });
}

export const fetchServiceAccountMappingsGet = (
  accountId?: string
): Promise<AccountMapping> =>
  axios
    .get("/landing/nxlambda/serviceAccountMappings/" + accountId)
    .then(res => res.data);

export const fetchServiceAccountMappingsUpdate = (
  config: AccountMapping
): Promise<AccountMapping> =>
  axios
    .post("/landing/nxlambda/serviceAccountMappings/", config)
    .then(res => res.data);
